import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const Volume = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0047 21.1211C16.879 20.7253 17.6831 20.2264 18.4169 19.6247C19.1507 19.0071 19.783 18.3064 20.3138 17.5226C20.8447 16.7387 21.2584 15.8797 21.555 14.9454C21.8517 14.0111 22 13.0293 22 12C22 10.9707 21.8517 9.98892 21.555 9.05463C21.2584 8.12034 20.8447 7.26129 20.3138 6.47743C19.783 5.69358 19.1507 4.99288 18.4169 4.3753C17.6831 3.77355 16.879 3.27474 16.0047 2.87886V4.89786C16.598 5.26208 17.1366 5.68963 17.6206 6.18052C18.1202 6.68726 18.5457 7.24544 18.897 7.85511C19.2482 8.46477 19.5176 9.11797 19.7049 9.81473C19.8923 10.5273 19.9859 11.2557 19.9859 12C19.9859 12.7443 19.8923 13.4727 19.7049 14.1853C19.5176 14.882 19.2482 15.5352 18.897 16.1449C18.5457 16.7546 18.1202 17.3127 17.6206 17.8195C17.1366 18.3104 16.598 18.7379 16.0047 19.1021V21.1211ZM16.0047 6.94062V17.0594C16.6136 16.5051 17.0976 15.749 17.4567 14.791C17.8158 13.8329 17.9953 12.9026 17.9953 12C17.9953 11.0974 17.8158 10.1671 17.4567 9.20903C17.0976 8.25098 16.6136 7.49486 16.0047 6.94062ZM4.01405 17.0594H6.70726L13.9906 22V2L6.70726 6.94062H4.01405C3.45199 6.94062 2.9758 7.13856 2.58548 7.53444C2.19516 7.93033 2 8.40538 2 8.95962V15.0404C2 15.5946 2.19516 16.0697 2.58548 16.4656C2.9758 16.8614 3.45199 17.0594 4.01405 17.0594Z"
        fill="currentColor"
      />
    </svg>
  )
})

export default Volume

Volume.displayName = 'Volume'
